/*
 * @author Lemuel Raganas <lemuel.raganas@mediacorp.com.sg>
 **/

import DataRepoOption from "@/libs/world-cup/DataRepoOption";
import * as lobj from "lodash/object";

export default class DataRepoUtil {
  private dataRepos?: DataRepoOption[];
  private componentName: string;

  constructor(componentName: string, dataRepos: DataRepoOption[]) {
    this.componentName = componentName;

    if (dataRepos === undefined || !Array.isArray(dataRepos)) {
      this.dataRepos = [];
    } else {
      this.dataRepos = dataRepos;
    }
  }

  getDataRepo(): DataRepoOption[] {
    const that = this;
    let dataRepo: DataRepoOption[] = [];

    // All endpoints for data broker
    if (this.componentName === "data-broker") {
      dataRepo = [
        { name: "checksum", preload: true, pull: true },
        { name: "labels", preload: true, pull: false },
        {
          name: "externalTranslation",
          preload: true,
          pull: true,
        },
        { name: "worldCupMatches", preload: true, pull: true },
      ];
    }

    if (this.componentName == "match-table" || this.componentName == "fixture" || this.componentName == "match" || this.componentName == "knockout" || this.componentName == "most-relevant") {
      dataRepo = [{ name: "worldCupMatches", preload: true, pull: true }];
    }

    if (this.componentName == "points-table") {
      dataRepo = [{ name: "pointsTable", preload: true, pull: true }];
    }

    const mergedRepo = this.dataRepos === undefined ? [] : this.dataRepos;
    dataRepo.forEach((i) => {
      if (!that.hasRepo(i.name)) {
        mergedRepo.push(i);
      }
    });
    return mergedRepo;
  }

  hasRepo(name: string) {
    if (this.dataRepos === undefined) {
      return false;
    }

    if (this.dataRepos.length <= 0) {
      return false;
    }

    for (let i = 0; i < this.dataRepos.length; i++) {
      const repo = this.dataRepos[i];

      if (repo.name === name) {
        return true;
      }
    }

    return false;
  }

  getOption(name: string): DataRepoOption {
    const dataRepoOption = this.dataRepos.find((item) => {
      if (item.name === name) {
        return true;
      }

      return false;
    });

    return dataRepoOption;
  }

  getRepos() {
    return this.dataRepos;
  }

  getAllNames(): string[] {
    let names: string[];

    this.dataRepos.forEach((opt) => {
      names.push(opt.name);
    });

    return names;
  }
}
